import styles from './LessonsLayout.module.scss'
import { SllLesson } from '@src/api/graphql-codegen'
import CoverContent from '@src/components/CoverContent/CoverContent'
import DropBox from './DropBox'
import {
  DragDropContext,
  Droppable,
  Draggable,
  DropResult,
  ResponderProvided,
  DraggableProvided,
  DroppableProvided,
  DraggableStateSnapshot,
} from 'react-beautiful-dnd'
import { useCallback } from 'react'

type Props = {
    contents: any[]
    source: number
    target?: string
    handleDrop: (index: number, unit: any) => void
    handleRemoveContentAction?: (unit: any) => void
    isNewMovable?: boolean  // New Cover moving state
    handleDnDOnLessonList?: (index: number, lessons: string[]) => void
}

const reorder = (list: any, startIndex: number, endIndex: number) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
  
    return result;
};

function LessonsLayout(props: Props) {
    const { contents, source, target, isNewMovable, handleDrop, handleRemoveContentAction, handleDnDOnLessonList } = props

    const handleDragEnd = useCallback((result: DropResult, provided?: ResponderProvided) => {
        if (!result.destination) {
          return;
        }
        if (result.destination.index === result.source.index) {
          return;
        }
        const sourceIndex = result.source.index;
        const destIndex = result.destination.index;
    
        const updateLessons = reorder(contents, sourceIndex, destIndex) as any[]
        const lessonIds = updateLessons.map((item: SllLesson) => {
          return item.id
        })
        if (handleDnDOnLessonList) {
            handleDnDOnLessonList(source, lessonIds)
        }
    }, [source, contents, handleDnDOnLessonList]);
    
    return (
        <div className={styles.normalDiv }>
            <DropBox
                accept={"type"}
                onDrop={(item) => handleDrop(source, item)}
                isAusCourse={true}
                isNewMovable={isNewMovable}
            />
            <DragDropContext onDragEnd={handleDragEnd}>
                <Droppable droppableId="droppableLesson" type="StudyPlanItems">
                {(droppableProvided: DroppableProvided) => (
                    <div
                        ref={droppableProvided.innerRef}
                        {...droppableProvided.droppableProps}
                    >
                    {(contents || []).map((content, index) => (
                        <Draggable
                        key={content.id}
                        draggableId={content.id}
                        index={index}
                      >
                        {(
                          draggableProvided: DraggableProvided,
                          snapshot: DraggableStateSnapshot
                        ) => {
                        return (
                            <div
                                ref={draggableProvided.innerRef}
                                {...draggableProvided.draggableProps}
                            >
                                <CoverContent
                                    draggableProvided={draggableProvided}
                                    snapshot={snapshot} 
                                    key={index}
                                    type={"type"}
                                    source={'grade'}
                                    target={target}
                                    content={content}
                                    handleRightArrowAction={() => handleRemoveContentAction && handleRemoveContentAction(content)}
                                />
                            </div>
                    )
                }}
                </Draggable>
              ))}
              {droppableProvided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
        </div>
    )
}

export default LessonsLayout